<style lang="scss" scoped>
.tips {
    margin: 15px 20px;
}
.text-red {
    color: #ed4014;
}
</style>
<template>
    <div class="reduce-number">
        <div>
            <Form ref="validForm" :model="cancelAutoCreatePr">
                <FormItem
                    :labelWidth="220"
                    :label="
                        $t('boss.purchase.reducing_the_quantity_a', {
                            defaultValue: '减少数量是否自动创建采购申请单',
                        })
                    "
                    prop="cancelAutoCreatePr"
                    :rules="required"
                >
                    <RadioGroup size="small" v-model="cancelAutoCreatePr">
                        <Radio label="0">{{
                            $t("boss.purchase.deny", { defaultValue: "否" })
                        }}</Radio>
                        <Radio label="1">{{
                            $t("boss.purchase.correct", { defaultValue: "是" })
                        }}</Radio>
                    </RadioGroup>
                </FormItem>
            </Form>
        </div>
        <div class="tips">
            <div class="text-red">Tips:</div>
            <ul class="text-red" v-if="type === 1">
                <li>
                    {{
                        $t("boss.purchase.cannot_be_delivered", {
                            defaultValue:
                                "1.确认无法交货的SKU，可以取消其采购数量",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.completely_cancelled", {
                            defaultValue:
                                "2.SKU已发运的数量不可取消，未发运的数量可以部分或全部取消",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.after_clicking_a", {
                            defaultValue:
                                "3.点了确定按钮后，实际发运数量和未发运数量会重新计算。",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.actual_purchase_quantity_a", {
                            defaultValue: "实际采购数量=原采购数量-取消数量",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.unshipped_quantity", {
                            defaultValue: "未发运数量=实际采购数量-已发运数量",
                        })
                    }}
                </li>
            </ul>
            <ul class="text-red" v-else>
                <li>
                    {{
                        $t("boss.purchase.cannot_be_delivered", {
                            defaultValue:
                                "1.确认无法交货的SKU，可以取消其采购数量",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.clicking_will_uncheck", {
                            defaultValue:
                                "2.点击后将会取消勾选SKU的所有未发运数量，请谨慎操作！",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.after_clicking_a", {
                            defaultValue:
                                "3.点了确定按钮后，实际发运数量和未发运数量会重新计算。",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.actual_purchase_quantity_a", {
                            defaultValue: "实际采购数量=原采购数量-取消数量",
                        })
                    }}
                </li>
                <li>
                    {{
                        $t("boss.purchase.unshipped_quantity", {
                            defaultValue: "未发运数量=实际采购数量-已发运数量",
                        })
                    }}
                </li>
            </ul>
        </div>
        <div class="table">
            <Table
                class="margin-20"
                :columns="type === 1 ? reduceColumns : autoReduceColumns"
                :data="reduceList"
                size="small"
                ref="table1"
                @on-selection-change="selectChange"
                border
            ></Table>
        </div>
        <!-- <div class="copy-data" style="position: absolute; opacity: 0">
            <ul>
                <li v-for="item in reduceList" :key="item.key">
                    <div>{{ item.erpsku }}</div>
                    <div class="copy-cancel-reason">
                        {{ item.incrementCancelReason }}
                    </div>
                </li>
            </ul>
        </div> -->
        <div class="button" style="margin: 20px; text-align: right">
            <Button
                v-if="type === 1 && reduceList.length > 0"
                class="margin-right-15"
                type="success"
                @click="confirm"
                :disabled="sending"
                >{{
                    $t("boss.purchase.sure", { defaultValue: "确定" })
                }}</Button
            >
            <Button
                v-else-if="type === 2 && reduceList.length > 0"
                class="margin-right-15"
                type="success"
                @click="confirm"
                :disabled="sending"
                >{{
                    $t("boss.purchase.confirm_reduction", {
                        defaultValue: "确定一键减少",
                    })
                }}</Button
            >
            <Button @click="cancel">{{
                $t("boss.purchase.cancel", {
                    defaultValue: "取消",
                })
            }}</Button>
        </div>
    </div>
</template>

<script>
import {
    HttpReduceQuantity,
    HttpAutoReduceQuantity,
} from "@/service/purchase/purchase";
export default {
    props: ["id", "type", "dataList"],
    watch: {
        dataList: {
            immediate: true,
            handler(val) {
                this.reduceList = [...val];
                this.reduceList.map((item) => {
                    item.incrementCancelQuantity = "";
                    item.incrementCancelReason = "";
                });
            },
        },
    },
    data() {
        return {
            reduceList: [],
            selectionList: [],
            sending: false,
            required: [
                {
                    required: true,
                    message: " ",
                },
            ],
            cancelAutoCreatePr: null,
        };
    },
    mounted() {
        // 筛选未发运数量>0的列
        for (let i = 0; i < this.reduceList.length; ) {
            let item = this.reduceList[i];
            if (item.notSendNum <= 0) {
                this.reduceList.splice(i, 1);
            } else {
                i++;
            }
        }
    },
    computed: {
        reduceColumns() {
            return [
                {
                    title: "ERP SKU",
                    key: "erpsku",
                },
                {
                    title: this.$t("boss.purchase.source_application_number", {
                        defaultValue: "来源申请单号",
                    }),
                    key: "poRequisitionOrderNo",
                },
                {
                    title: this.$t("boss.purchase.original_purchase_quantity", {
                        defaultValue: "原采购数量",
                    }),
                    key: "quantity",
                },
                {
                    title: this.$t("boss.purchase.actual_purchase_quantity", {
                        defaultValue: "实际采购数量",
                    }),
                    render: (h, { row }) => {
                        return <div>{row.inFactNum}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.unshipped_quantity", {
                        defaultValue: "未发运数量",
                    }),
                    render(h, { row }) {
                        return <div>{row.notSendNum}</div>;
                    },
                },
                {
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h(
                                "strong",
                                this.$t("boss.purchase.cancel_quantity", {
                                    defaultValue: "取消数量",
                                })
                            ),
                        ]);
                    },
                    render: (h, { row }) => {
                        return h("Input", {
                            props: {
                                value: this.value,
                            },
                            on: {
                                input: () => {
                                    this.$emit("input", event.target.value);
                                    this.reduceList.map((item) => {
                                        if (item.id === row.id) {
                                            item.incrementCancelQuantity =
                                                event.target.value;
                                        }
                                    });
                                },
                            },
                        });
                    },
                },
                {
                    width: 140,
                    renderHeader: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    display: "inline-block",
                                    cursor: "pointer",
                                    "margin-left": "10px",
                                },
                            },
                            [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                }),
                                h(
                                    "strong",
                                    this.$t(
                                        "boss.purchase.reason_cancellation",
                                        {
                                            defaultValue: "取消原因",
                                        }
                                    )
                                ),
                                // h(
                                //     "Tooltip",
                                //     {
                                //         props: {
                                //             placement: "top",
                                //             // transfer:true,
                                //             content:
                                //                 "点击该按钮，将以第一行的交货日期，填充以下所有行本次交货日期的框内",
                                //         },
                                //     },
                                //     [
                                h("Icon", {
                                    props: {
                                        type: "ios-copy-outline",
                                        size: "15",
                                    },
                                    style: {
                                        cursor: "pointer",
                                    },
                                    attrs: {
                                        title: this.$t(
                                            "boss.purchase.copy_cancellation_reason",
                                            {
                                                defaultValue: "复制取消原因",
                                            }
                                        ),
                                    },
                                    style: {
                                        "margin-left": "5px",
                                    },
                                    on: {
                                        click: () => {
                                            let cancelReason =
                                                this.reduceList[0]
                                                    .incrementCancelReason;
                                            if (!cancelReason)
                                                return this.$VMessage.error(
                                                    this.$t(
                                                        "boss.purchase.first_reason",
                                                        {
                                                            defaultValue:
                                                                "请填写第一个取消原因",
                                                        }
                                                    )
                                                );
                                            this.reduceList.map(
                                                (item, index) => {
                                                    this.$set(
                                                        this.reduceList,
                                                        index,
                                                        {
                                                            ...item,
                                                            incrementCancelReason:
                                                                cancelReason,
                                                        }
                                                    );
                                                }
                                            );
                                        },
                                    },
                                }),
                                //     ]
                                // ),
                            ]
                        );
                    },
                    render: (h, { row, index }) => {
                        return h("div", [
                            h("Input", {
                                props: {
                                    value: this.reduceList[index]
                                        .incrementCancelReason,
                                },
                                on: {
                                    "on-change": () => {
                                        this.reduceList[
                                            index
                                        ].incrementCancelReason =
                                            event.target.value;
                                    },
                                },
                            }),
                        ]);
                    },
                },
            ];
        },
        autoReduceColumns() {
            return [
                {
                    width: 55,
                    type: "selection",
                    title: "",
                },
                {
                    title: "ERP SKU",
                    key: "erpsku",
                },
                {
                    title: this.$t("boss.purchase.source_application_number", {
                        defaultValue: "来源申请单号",
                    }),
                    key: "poRequisitionOrderNo",
                },
                {
                    title: this.$t("boss.purchase.original_purchase_quantity", {
                        defaultValue: "原采购数量",
                    }),
                    key: "quantity",
                },
                {
                    title: this.$t("boss.purchase.actual_purchase_quantity", {
                        defaultValue: "实际采购数量",
                    }),
                    render: (h, { row }) => {
                        return <div>{row.inFactNum}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.unshipped_quantity", {
                        defaultValue: "未发运数量",
                    }),
                    render(h, { row }) {
                        return <div>{row.notSendNum}</div>;
                    },
                },
                {
                    width: 120,
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h(
                                "strong",
                                this.$t("boss.purchase.reason_cancellation", {
                                    defaultValue: "取消原因",
                                })
                            ),
                            h("Icon", {
                                props: {
                                    type: "ios-copy-outline",
                                    size: "15",
                                },
                                attrs: {
                                    title: this.$t(
                                        "boss.purchase.copy_cancellation_reason",
                                        {
                                            defaultValue: "复制取消原因",
                                        }
                                    ),
                                },
                                style: {
                                    "margin-left": "5px",
                                },
                                on: {
                                    click: () => {
                                        // this.$emit("input", event.target.value);
                                        // let list = document.querySelectorAll(
                                        //     ".copy-cancel-reason"
                                        // );
                                        // for (let i = 0; i < list.length; i++) {
                                        //     if (list[i].innerText) {
                                        //         return this.handleCopy(list[i]);
                                        //     }
                                        // }

                                        let cancelReason =
                                            this.reduceList[0]
                                                .incrementCancelReason;
                                        if (!cancelReason)
                                            return this.$VMessage.error(
                                                this.$t(
                                                    "boss.purchase.first_reason",
                                                    {
                                                        defaultValue:
                                                            "请填写第一个取消原因",
                                                    }
                                                )
                                            );
                                        this.reduceList.map((item, index) => {
                                            this.$set(this.reduceList, index, {
                                                ...item,
                                                incrementCancelReason:
                                                    cancelReason,
                                            });
                                        });
                                    },
                                },
                            }),
                        ]);
                    },
                    // render: (h, { row }) => {
                    //     return h("div", [
                    //         h("Input", {
                    //             props: {
                    //                 value: row.incrementCancelReason,
                    //             },
                    //             on: {
                    //                 input: () => {
                    //                     this.$emit("input", event.target.value);
                    //                     this.reduceList.map((item, index) => {
                    //                         if (item.erpsku === row.erpsku) {
                    //                             this.$set(
                    //                                 this.reduceList[index],
                    //                                 "incrementCancelReason",
                    //                                 event.target.value
                    //                             );
                    //                         }
                    //                     });
                    //                     this.$forceUpdate();
                    //                 },
                    //             },
                    //         }),
                    //     ]);
                    // },
                    render: (h, { row, index }) => {
                        return h("div", [
                            h("Input", {
                                props: {
                                    value: this.reduceList[index]
                                        .incrementCancelReason,
                                },
                                on: {
                                    "on-change": () => {
                                        this.reduceList[
                                            index
                                        ].incrementCancelReason =
                                            event.target.value;
                                    },
                                },
                            }),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        async confirm() {
            if (!this.cancelAutoCreatePr) {
                return this.$VMessage.error(
                    this.$t("boss.purchase.whether_to_automatically", {
                        defaultValue: "减少数量是否自动创建采购申请单必填",
                    })
                );
            }
            // 减少采购数量
            if (this.type === 1) {
                let dataList = [...this.reduceList];
                console.log(this.dataList);
                for (let i = 0; i < dataList.length; ) {
                    if (dataList[i].incrementCancelQuantity) {
                        let cancelNum = dataList[i].incrementCancelQuantity;
                        cancelNum = parseInt(cancelNum);
                        if (cancelNum === 0) {
                            dataList.splice(i, 1);
                            continue;
                        }
                        if (isNaN(cancelNum) || cancelNum < 0)
                            return this.$VMessage.error(
                                `${dataList[i].erpsku}` +
                                    this.$t("boss.purchase.positive_integer", {
                                        defaultValue: "的取消数量必须为正整数",
                                    })
                            );
                        if (!dataList[i].incrementCancelReason)
                            return this.$VMessage.error(
                                this.$t("boss.purchase.need_fill", {
                                    defaultValue: "需要填写",
                                }) +
                                    `${dataList[i].erpsku}` +
                                    this.$t(
                                        "boss.purchase.reason_for_cancellation",
                                        {
                                            defaultValue: "的取消原因",
                                        }
                                    )
                            );
                        i++;
                    } else {
                        dataList.splice(i, 1);
                    }
                }
                if (!dataList.length)
                    return this.$VMessage.error(
                        this.$t("boss.purchase.please_fill_data", {
                            defaultValue: "请至少填写一行数据",
                        })
                    );
                let poOrderItem = dataList.map((item) => {
                    return {
                        id: item.id,
                        incrementCancelQuantity: item.incrementCancelQuantity,
                        incrementCancelReason: item.incrementCancelReason,
                    };
                });
                this.sending = true;
                await HttpReduceQuantity({
                    id: this.id,
                    orgId: global.SYSID,
                    cancelAutoCreatePr: this.cancelAutoCreatePr,
                    poOrderItem: poOrderItem,
                })
                    .then(
                        (res) => {
                            this.$VMessage.success(res.message);
                            this.$emit("on-success");
                            this.cancel();
                        },
                        (err) => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    )
                    .finally(() => {
                        this.sending = false;
                    });
            }
            // 一键减少采购数量
            else {
                if (!this.selectionList.length) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.check_cancel_SKU", {
                            defaultValue: "请勾选需要取消的SKU",
                        })
                    );
                }
                let poOrderItem = this.selectionList.map((item) => {
                    return {
                        id: item.id,
                        incrementCancelReason: item.incrementCancelReason,
                    };
                });
                this.sending = true;
                await HttpAutoReduceQuantity({
                    id: this.id,
                    orgId: global.SYSID,
                    poOrderItem: poOrderItem,
                    cancelAutoCreatePr: this.cancelAutoCreatePr,
                })
                    .then(
                        (res) => {
                            this.$VMessage.success(res.message);
                            this.$emit("on-success");
                            this.cancel();
                        },
                        (err) => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    )
                    .finally(() => {
                        this.sending = false;
                    });
            }
        },
        cancel() {
            this.$emit("on-close");
            this.reduceList = [];
        },
        selectChange(selection) {
            this.selectionList = selection;
        },
    },
};
</script>
